export default {"src":"/_next/static/media/viewAllOnHover.a37d9cd2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};